export function getUID() {
  function chr4() {
    return Math.random()
      .toString(16)
      .slice(-4);
  }

  return (
    chr4() + chr4() + '-' + chr4() + '-' + chr4() + '-' + chr4() + '-' + chr4() + chr4() + chr4()
  );
}

export function isID(id) {
  return !(isNaN(id) || isNaN(parseInt(id)) || parseInt(id) <= 0);
}
